import { SCOPE_TYPE } from "@model";

export const VFA_ADVANCED_METRICS_QUERY_FLAG = "advancedMetrics";

export function hasVfaAdvancedMetrics(test: { orgScope?: string[] } | null | undefined): boolean {
  return Boolean(test?.orgScope?.includes(SCOPE_TYPE.vfaAdvancedMetrics));
}

export function isVfaAdvancedMetricsVisible(
  test: { orgScope?: string[] } | null | undefined,
  enabledByUser: boolean,
  queryFlag: string | null | undefined,
): boolean {
  if (!hasVfaAdvancedMetrics(test)) {
    return false;
  }
  if (queryFlag === "true") {
    return true;
  }
  if (queryFlag === "false") {
    return false;
  }
  return enabledByUser;
}
